<template>
  <div class="menu-box">
    <el-menu background-color="#ffffff"
             text-color="#444444"
             active-text-color="#409eff"
             :router="true"
             :default-active="defaultActive">
          <template v-for="(menuItem, index) in menuList">
              <template v-if="designerMenu.indexOf(menuItem.path) !== -1 && !designerVisible">
              </template>
              <template v-else-if="menuItem.path==='/auth' && !designerVisible && !applyVisible">
              </template>
              <template v-else>
                  <el-submenu v-if="menuItem.children && menuItem.children.length !==0"
                            :key="index"
                            :index="index.toString()"
                            >
                  <template slot="title">
                    <i :class="menuItem.icon"></i>
                    <span>{{menuItem.name}}</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item v-for="(menuLink, indexChild) in menuItem.children"
                                  :index="menuLink.path"
                                  :key="indexChild"><span class="diy-menu-item-inner">{{menuLink.name}}</span></el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-menu-item  v-if="!menuItem.children && menuItem.name" :index="menuItem.path" :key="menuItem.path">
                  <div class="diy-menuItem-box"><i :class="menuItem.icon"></i><span>{{menuItem.name}}</span></div>
                </el-menu-item>
              </template>
          </template>
    </el-menu>
  </div>
</template>
<script>
export default {
    props: {
        designerVisible: Boolean,
        applyVisible: Boolean
    },
    data () {
        return {
            menuList: [],
            designerMenu: [
                '/designer'
            ]
        }
    },

    computed: {
        defaultActive () {
            // 判断匹配动态路由处理 默认激活主菜单
            if (this.$route.params && this.$route.params.id === 'add') {
                return this.$route.matched[2].path.split(':')[0] + 'main'
            }
            return this.$route.path
        }
    },
    created () {
        const tempMenu = this.$router.options.routes.filter((item) => {
            return item.name === 'layout'
        })
        this.menuList = tempMenu[0].children.filter((item) => {
            return item.type !== 0
        })
    },
    methods: {
        // menuHelper (path) {
        //     if (path.indexOf(':id') !== -1) {
        //         return path && path.split(':')[0] + '/list'
        //     }
        //     return path
        // }
    }
}
</script>
<style lang="scss" scoped>
.menu-box{
  font-size: 16px;
  padding-top: 10px;
  i{
    display: inline-block;
    width: 18px;
    height: 18px;
    vertical-align: middle;
    position: relative;
    left: -4px;
  }
  .el-submenu__title{
      padding: 0 18px;
  }
  .diy-menu-item-inner{
    display: block;
      padding-left: 80px !important;
      box-sizing: border-box;
      position: relative;
  }

 li.el-submenu:hover,li.el-menu-item:hover{
    background: #ecf6fe !important;
  }
  .el-menu-item.is-active{
    background: #ecf6fe !important;
      span.diy-menu-item-inner:before{
        content:  '';
        position: absolute;
        left: 0;
        top:0;
        height: 100%;
        width:4px;
        background: #45a5fa;
      }
  }
  .el-submenu .el-menu-item {
    padding-left: 0 !important;

  }

}
.el-submenu.is-active {
  .icon-resource-manage{
    background-position: -36px -29px;
  }
  .icon-client-manage{
    background-position: -36px -72px;
  }
}
.menu-text{
    font-size: 20px;
    color:#333;
}
.logo-box{
  padding-top: 55px;
  padding-bottom: 71px;
  padding-left: 55px;
  box-sizing: border-box;
  color: #333;
  font-size: 20px;
  p{
    margin-top: 9px;
  }

}

.diy-menuItem-box{
  padding-left: 36px;
  position: relative;
}
.is-active .diy-menuItem-box:before{
  content: '';
  position: absolute;
  left: -20px;
  top:0;
  width: 18px;
  height: 98%;
  width: 4px;
  background: #45a5fa;
}

</style>



// WEBPACK FOOTER //
// src/components/layout/menu.vue